
import React, { useState } from "react";
import CalculatorPage from "@/components/calculator/CalculatorPage";
import FlowCalculatorHeader from "@/components/calculator/flow/FlowCalculatorHeader";
import FlowCalculatorCard from "@/components/calculator/flow/FlowCalculatorCard";

const FlowRateCalculator = () => {
  const [activeTab, setActiveTab] = useState("classic");

  return (
    <CalculatorPage
      title="Flow Ratio Calibration Calculator - Slicer Flow Ratio Tuning Tool"
      mobileTitle="Flow Ratio Calc"
      description="Calculate optimal flow ratios for OrcaSlicer using Classic 2-Pass or YOLO methods. Mobile-first flow rate calculator for 3D printing."
      keywords="OrcaSlicer, flow rate calculator, flow ratio, 3D printing calibration, YOLO method, classic method"
      canonicalUrl="https://3dphub.net/tools/flow-rate"
      footerText="3DP Hub | Slicer Flow Ratio Calibration Calculator"
      calculatorTitle="Flow Ratio Calculator"
      calculatorDescription="Calibrate your flow ratio for optimal 3D printing results"
    >
      <FlowCalculatorHeader />
      <FlowCalculatorCard method={activeTab as "classic" | "yolo"} />
    </CalculatorPage>
  );
};

export default FlowRateCalculator;
